import './base'

// we need a separate application bundle that will not be fully digested by base
console.log('')
